var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllProjectEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 634133"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1658_2924",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 111,
    height: 111
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#F4F4F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1658_2924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 634000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3170",
    x: 76.368,
    y: 41.736,
    width: 39.5108,
    height: 54.168,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3167",
    x: 82.1035,
    y: 75.1787,
    width: 28.6772,
    height: 3.76821,
    rx: 1.8841,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3172",
    x: 82.1035,
    y: 82.2441,
    width: 22.3045,
    height: 3.76821,
    rx: 1.8841,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3171",
    x: 82.1035,
    y: 45.504,
    width: 28.6772,
    height: 26.3775,
    rx: 6,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 634001"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3170_2",
    x: -4.43994,
    y: 41.736,
    width: 39.5108,
    height: 54.168,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3167_2",
    x: 1.29553,
    y: 75.1787,
    width: 28.6772,
    height: 3.76821,
    rx: 1.8841,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3172_2",
    x: 1.29553,
    y: 82.2441,
    width: 22.3045,
    height: 3.76821,
    rx: 1.8841,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3171_2",
    x: 1.29553,
    y: 45.504,
    width: 28.6772,
    height: 26.3775,
    rx: 6,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 633999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 3170_3",
    filter: "url(#filter0_d_1658_2924)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.856,
    y: 27.528,
    width: 45.0023,
    height: 83.472,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.356,
    y: 28.028,
    width: 44.0023,
    height: 82.472,
    rx: 5.5,
    stroke: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3167_3",
    x: 39.3885,
    y: 79.0626,
    width: 32.663,
    height: 5.80675,
    rx: 2.90337,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3172_3",
    x: 39.3885,
    y: 89.9504,
    width: 25.4045,
    height: 5.80675,
    rx: 2.90337,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3171_3",
    x: 39.3885,
    y: 33.3346,
    width: 32.663,
    height: 40.6472,
    rx: 6,
    fill: "#F8F8F8"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1658_2924",
    x: 24.856,
    y: 21.528,
    width: 61.0023,
    height: 99.472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1658_2924"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1658_2924",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllProjectEmpty);
export default __webpack_public_path__ + "static/media/allProjectEmpty.744f62cddc4f4ecf2a542d7bbcb6654f.svg";
export { ForwardRef as ReactComponent };